import $ from 'jquery'

export function initialise() {
  updateOverviewHeight()
}

function updateOverviewHeight() {
  setTimeout(function () {
    const $showAccordionButton = $('[data-toggle-accordion-item]')

    $showAccordionButton.on('click', function () {
      const $this = $(this)
      const id = $this.data('toggle-accordion-item')
      const $target = $(`[accordion-item="${id}"]`)
      const $targetHeight = $(`[data-toggle-target-accordion-item="${id}"]`).height()

      if ($this.hasClass('open')) {
        $target.css('max-height', `calc(${$targetHeight}px + 132px)`)
        $this.find('svg').html('<use xlink:href="/assets/glyphs/glyphs.svg#minus"></use>')
      } else {
        $target.css('max-height', '')
        $this.find('svg').html('<use xlink:href="/assets/glyphs/glyphs.svg#plus"></use>')
      }
    })
  }, 200)
}
